import React, { Component } from 'react'
import parse from 'html-react-parser';

import "./style.scss";

// Icons
import IconClose from '@learningblocks/protocol-constants/lib/Icons/close-solid';

// Styles
//import colors from '@learningblocks/protocol-constants/lib/Styles/_colors.scss';

export class SolutionContents extends Component {

constructor(props) {
  super(props)

  this.state = {
  }
}

  toggle = () => {
      this.props.setShowSolutionContents({
        id: this.props.id,
        showSolutionContents: !this.props.display
      });
  }
  hide = () => {
      this.props.setShowSolutionContents({
        id: this.props.id,
        showSolutionContents: false
      });
  }
  show = () => {
      this.props.setShowSolutionContents({
        id: this.props.id,
        showSolutionContents: true
      });
  }

  showContentsList = (solutions) => {

      let list = Object.keys(solutions).map(solution =>
        <tr>
          <td>{solutions[solution]}μl</td>
          <td>{(
            solution !== 'DNA A' &&
            solution !== 'DNA B' &&
            solution !== 'DNA C'
          )?solution:'PCR sample 1 - unknown'}</td>
        </tr>
      )

      return (
        <table>
          {(list.length > 0)?list:(<tr><td>Empty</td></tr>)}
        </table>
      );//outArr
  }

  getLabel = () => {
    const { labelReactionTubes, renamable, solutionAlias, fullName } = this.props
    if (!labelReactionTubes && renamable) {
      return solutionAlias
    }
    return fullName
  }

  render(){
    return(
      <div className="solution-contents-box">
        <div className="wrapper">
          <div
            style={{display: (this.props.display)?null:'none'}}
            className="collapse"
            aria-hidden={!this.props.display}
            tabIndex={(this.props.display)? null: -1}>
            <div className="solution-contents-dialog">
              <div className="solution-contents-dialog-head">
                <h5>{this.getLabel() === "Distilled water (dH20)" ? parse("Distilled water (dH<sub>2</sub>0)"): parse(this.getLabel())} contents</h5>
                <div tabIndex="0" className="close" onKeyDown={ (e)=>{if(e.keyCode === 13 || e.keyCode === 32) this.hide() } } onClick={this.hide}><IconClose /></div>
              </div>
              <div className="solution-contents-dialog-body">
                <table>
                  {(Object.keys(this.props.solutions).length > 0)?Object.keys(this.props.solutions).map(solution =>
                    <tr>
                      <td>{Math.round(this.props.solutions[solution] * 1000) / 1000}μl</td>
                      <td>{(
                        solution !== 'DNA A' &&
                        solution !== 'DNA B' &&
                        solution !== 'DNA C'
                      )?solution:'PCR sample 1 - unknown'}</td>
                    </tr>
                  ):(<tr><td>Empty</td></tr>)}
                </table>
                {/*this.showContentsList(this.props.solutions)*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}
